import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getAllPosOrders = async (params = {}) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/pos-orders/list`, {
      params,
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("getAllPosOrders API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch POS orders" };
  }
};

export const getPosOrderDetail = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/pos-orders/detail/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("getPosOrderDetail API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch POS order detail" };
  }
};

export const updatePosOrder = async (id, payload) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/pos-orders/update/${id}`,
      payload,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("updatePosOrder API Error:", error);
    throw error?.response?.data || { message: "Failed to update POS order" };
  }
};

export const deletePosOrder = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/pos-orders/delete/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("deletePosOrder API Error:", error);
    throw error?.response?.data || { message: "Failed to delete POS order" };
  }
};

export const getPosOrderPayments = async (id) => {
  try {
    const response = await api.get(`${API_BASE_URL}api/pos-orders/payments/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("getPosOrderPayments API Error:", error);
    throw error?.response?.data || { message: "Failed to fetch payments" };
  }
};

export const createPosOrderPayment = async (id, payload) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/pos-orders/payments/create/${id}`,
      payload,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("createPosOrderPayment API Error:", error);
    throw error?.response?.data || { message: "Failed to create payment" };
  }
};

export const downloadPosOrderPdf = async (id) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/pos-orders/download-pdf/${id}`,
      {
        headers: authHeaders(),
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    console.error("downloadPosOrderPdf API Error:", error);
    throw error?.response?.data || { message: "Failed to download PDF" };
  }
};